import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Register from "./Register";
import Emergency from "./Emergency";

function UserPage() {
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_CHECK_URL}/${id}`)
            .then(res => res.json())
            .then(data => setData(data));
    }, [id]);

    if (!data) return <p>Loading...</p>;

    return data.registered ? (
        <Emergency data={data} />
    ) : (
        <Register id={id} />
    );
}

export default UserPage;